import { render, staticRenderFns } from "./biantengMb.vue?vue&type=template&id=19649e00&scoped=true&"
import script from "./biantengMb.vue?vue&type=script&lang=js&"
export * from "./biantengMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19649e00",
  null
  
)

export default component.exports